import React from 'react'
import { NewChat } from './NewChat'
import { Search } from './Search'
import { DotsHoriz } from './DotsHoriz'
import { DotsVertical } from './DotsVertical'
import { SelectionDot } from './SelectionDot'
import { Microphone } from './Microphone'
import { MicrophoneOff } from './MicrophoneOff'
import { SendMessage } from './SendMessage'
import { GaiaTopicMeditation } from './GaiaTopicMeditation'
import { GaiaTopicYoga } from './GaiaTopicYoga'
import { GaiaTopicBonzai } from './GaiaTopicBonzai'
import { GaiaTopicHamsa } from './GaiaTopicHamsa'
import { Reroll } from './Reroll'
import { Copy } from './Copy'
import { ThumbsUp } from './ThumbsUp'
import { ThumbsDown } from './ThumbsDown'
import { ThumbsUpFilled } from './ThumbsUpFilled'
import { ThumbsDownFilled } from './ThumbsDownFilled'
import { Play } from './Play'
import { Heart } from './Heart'
import { HeartOff } from './HeartOff'
import { StarAi } from './StarAi'
import { Stones } from './Stones'
import { Panel } from './Panel'
import { Close } from './Close'
import { NewTab } from './NewTab'
import { ArrowRight } from './ArrowRight'
import { ArrowDown } from './ArrowDown'
import { Logo } from './Logo'
import { Voice } from './Voice'
import { Stop } from './Stop'
import { Meditation } from './Meditation'
import { Trash } from './Trash'
import { Pencil } from './Pencil'
import { Plus } from './Plus'
import { ChevronDown } from './ChevronDown'
import { ChevronUpBold } from './ChevronUpBold'
import { SendChatPrompt } from './SendChatPrompt'
import { OracleCards } from './OracleCards'
import { Horoscope } from './Horoscope'
import { TarotCards } from './TarotCards'

export type IconName =
  | 'arrow-down'
  | 'arrow-right'
  | 'chevron-down'
  | 'chevron-up-bold'
  | 'close'
  | 'copy'
  | 'dots-horiz'
  | 'dots-vertical'
  | 'gaia-topic-bonzai'
  | 'gaia-topic-hamsa'
  | 'gaia-topic-meditation'
  | 'gaia-topic-yoga'
  | 'heart-off'
  | 'heart'
  | 'horoscope'
  | 'logo'
  | 'meditation'
  | 'microphone-off'
  | 'microphone'
  | 'new-chat'
  | 'new-tab'
  | 'oracle-cards'
  | 'panel'
  | 'pencil'
  | 'plus'
  | 'play'
  | 'reroll'
  | 'search'
  | 'selection-dot'
  | 'send-chat-prompt'
  | 'send-message'
  | 'star-ai'
  | 'stones'
  | 'stop'
  | 'tarot-cards'
  | 'thumbs-down-filled'
  | 'thumbs-down'
  | 'thumbs-up-filled'
  | 'thumbs-up'
  | 'trash'
  | 'voice'
export const makeIcon = (
  name: IconName,
  size?: string,
  customProps?: Record<string, unknown>,
): React.ReactElement => {
  switch (name) {
    case 'new-chat':
      return <NewChat size={size} />
    case 'new-tab':
      return <NewTab size={size} {...(customProps as React.ComponentProps<typeof NewTab>)} />
    case 'oracle-cards':
      return <OracleCards size={size} />
    case 'search':
      return <Search size={size} />
    case 'dots-horiz':
      return <DotsHoriz size={size} />
    case 'dots-vertical':
      return <DotsVertical size={size} />
    case 'selection-dot':
      return <SelectionDot size={size} />
    case 'send-chat-prompt':
      return <SendChatPrompt size={size} />
    case 'microphone':
      return <Microphone size={size} />
    case 'microphone-off':
      return <MicrophoneOff size={size} />
    case 'send-message':
      return <SendMessage size={size} />
    case 'gaia-topic-meditation':
      return <GaiaTopicMeditation size={size} />
    case 'gaia-topic-yoga':
      return <GaiaTopicYoga size={size} />
    case 'gaia-topic-bonzai':
      return <GaiaTopicBonzai size={size} />
    case 'gaia-topic-hamsa':
      return <GaiaTopicHamsa size={size} />
    case 'reroll':
      return <Reroll size={size} />
    case 'copy':
      return <Copy size={size} />
    case 'thumbs-up':
      return <ThumbsUp size={size} />
    case 'thumbs-down':
      return <ThumbsDown size={size} />
    case 'thumbs-up-filled':
      return <ThumbsUpFilled size={size} />
    case 'thumbs-down-filled':
      return <ThumbsDownFilled size={size} />
    case 'play':
      return <Play size={size} />
    case 'heart':
      return <Heart size={size} />
    case 'heart-off':
      return <HeartOff size={size} />
    case 'horoscope':
      return <Horoscope size={size} />
    case 'star-ai':
      return <StarAi size={size} />
    case 'stones':
      return <Stones size={size} />
    case 'panel':
      return <Panel size={size} />
    case 'pencil':
      return <Pencil size={size} />
    case 'plus':
      return <Plus size={size} />
    case 'close':
      return <Close size={size} />
    case 'arrow-down':
      return <ArrowDown size={size} />
    case 'arrow-right':
      return <ArrowRight size={size} />
    case 'chevron-down':
      return <ChevronDown size={size} />
    case 'chevron-up-bold':
      return <ChevronUpBold size={size} />
    case 'logo':
      return <Logo size={size} />
    case 'voice':
      return <Voice size={size} />
    case 'stop':
      return <Stop size={size} />
    case 'tarot-cards':
      return <TarotCards size={size} />
    case 'meditation':
      return <Meditation size={size} />
    case 'trash':
      return <Trash size={size} />
    default: {
      // Exhaustive switch - TypeScript will error if we miss a case
      const _exhaustive: never = name
      return _exhaustive
    }
  }
}
